<template>
  <div class="container">
    <div class="banner">
      <div>
        <div class="logo">
          <a href>
            <img src="../../assets/imgs/menu_logo@2x.png" alt />
          </a>
        </div>
        <div class="blank"></div>
        <div class="name">
          <el-dropdown style="margin-top: -20px">
            <div class="avatar-wrapper">
              <span style="white-space: nowrap">{{ userList.name }}</span>
              <i style="margin-left: 2px" class="el-icon-caret-bottom" />
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <button @click="onInfoShow" class="but">个人信息</button>
              </el-dropdown-item>
              <el-dropdown-item>
                <button class="but">退出登录</button>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="search-con">
        <div class="title">
          首页 /
          <span>应用图库</span>
        </div>
        <div class="search">
          <span>标签：</span>
          <!-- <input v-model="tagName" placeholder="" /> -->
          <el-input
            class="ipt"
            placeholder="请输入标签，多个标签可以用逗号隔开"
            v-model="tagName"
            clearable
            @clear="onTagNameClear"
            @change="getList"
          ></el-input>
          <span>标题：</span>
          <!-- <input v-model="title" placeholder="请输入标题" /> -->
          <el-input class="ipt" placeholder="请输入标题" v-model="title" clearable @clear="onNameClear" @change="getList"></el-input>
          <el-button size="mini" @click="getList" icon="el-icon-search">搜索</el-button>
        </div>
      </div>
      <div class="list-con">
        <div class="filter-con">
          <div class="title" style="padding-right: 0.2rem">所属分类</div>
          <div class="tag-con">
            <el-popover
              :key="tag.id"
              popper-class="last-check"
              v-for="tag in tagList"
              placement="bottom"
              trigger="click"
              :ref="'popover-' + tag.id"
              @show="onPopoverShow(tag.id)"
            >
              <div>
                <el-cascader-panel
                  v-model="tag.select"
                  @change="onCascaderChange"
                  :options="tag.childrens"
                  :props="tagProps"
                ></el-cascader-panel>
              </div>
              <span slot="reference" :class="['tag', getActive(tag)]">
                {{ tag.tagName }}
                <!-- {{ (tag.select || "").toString() || tag.tagName }} -->
                <i class="el-icon-arrow-down"></i>
              </span>
            </el-popover>
          </div>
        </div>
        <div class="filter-con" style="padding-top: 0" v-if="selectTags.length > 0">
          <div class="title">已选：</div>
          <div class="tag-con">
            <span class="sel-tag" v-for="tag in selectTags" :key="tag.join('-')">
              <!-- <template v-if="tag.indexOf(',') > -1">{{ tag.split(",")[1] }}</template>
              <template v-else>{{ tag }}</template> -->
              {{ tag.join("/") }}
              <span @click="onSelectTagRemove(tag)" class="del"></span>
            </span>
          </div>
        </div>
        <div class="imglist">
          <div class="list">
            <div class="item" :key="item.id" v-for="item in list">
              <div class="img">
                <!-- <el-tooltip effect="dark" placement="bottom">
                  <div slot="content">
                    <div>编号：{{ item.serialNumber }}</div>
                    <div>标签：{{ item.tagString }}</div>
                    <div>创建者：{{ item.createBy }}</div>
                </div>-->
<!--                <el-image-->
<!--                  fit="cover"-->
<!--                  style="width: 100%; height: 100%"-->
<!--                  :src="item.url"-->
<!--                  :preview-src-list="[item.url]"-->
<!--                ></el-image>-->
                <div
                  :style="{
                    background: `url('${item.url}') no-repeat center center /100% 100%`,
                    width: '100%',
                    height: '100%',
                    backgroundSize: 'cover'
                  }"
                  @mouseenter="bigPic(item)"
                  @mouseleave="bigPic(item)"
                >
                  <div class="image_show" v-if="item.imageShow" @click="openImage(item)">
                    <i class="el-icon-view"></i>
                  </div>
                </div>
<!--                <el-image-viewer-->
<!--                  v-if="showPreview"-->
<!--                  :on-close="closeViewer"-->
<!--                  :url-list="picList"-->
<!--                />-->
                <!-- </el-tooltip> -->
              </div>
              <div class="info">
                <div class="title">{{ item.image.name }}</div>
                <!-- <div class="tags">
                  {{ item.tagString }}
                </div>-->
                <div class="date">创建于 {{ item.createTime }}</div>
              </div>
            </div>
          </div>
        </div>
        <el-image
          ref="preview"
          class="hideImgDiv"
          :src="picList"
          :preview-src-list="[picList]"
          v-if="list.length != 0"
        ></el-image>
        <div class="boot-txt" v-if="loading">加载中...</div>
        <div class="boot-txt" v-if="noMore">没有更多了</div>
        <!-- <el-pagination
          style="text-align: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[12, 24, 48, 60]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>-->
      </div>
    </div>
    <!--个人信息-->
    <el-dialog :visible.sync="dialogUser" width="500px" style="width: 90%; margin: 0 auto" title="个人信息">
      <el-form :model="userList" label-position="right" label-width="100px">
        <el-form-item label="账号">
          <el-input disabled v-model="userList.qwUserId" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="所属公司">
          <el-input disabled v-model="userList.companyName" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="用户名">
          <el-input disabled v-model="userList.name" style="width: 300px"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

import { getGalleryList, getGalleryTagList } from "../../api/gallery";
let loadTimer = null;
export default {
  name: "Gallery",
  data() {
    return {
      picList: '',
      showPreview: false,
      userList: {},
      popoverId: null,
      tagName: "",
      title: "",
      tagList: [],
      list: [],
      pageNum: 1,
      pageSize: 12,
      tagProps: {
        multiple: true,
        value: "tagName",
        label: "tagName",
        children: "childrens",
      },
      userName: "获取中",
      dialogUser: false,
      loading: false,
      pages: 0,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    this.getuser();
    this.getAllTags();
  },

  created() {
    document.title = "应用图库";
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    bigPic(item) {
      item.imageShow = item.imageShow ? false : true
    },
    openImage(item) {
      // 调用image组件中的大图浏览图片方法
      this.$refs.preview.clickHandler()
      this.picList = item.urlSource
      this.showPreview = true
    },
    closeViewer() {
      this.list.forEach(item => {
        item.imageShow = false
      })
      // item.imageShow = false
      this.picList = []
      this.showPreview = false
    },
    getActive(tag) {
      return tag.select?.length > 0 ? "active" : "";
    },
    onTagNameClear() {
      this.tagName = "";
      this.pageNum = 1;
      this.getList();
    },
    onNameClear() {
      this.title = "";
      this.pageNum = 1;
      this.getList();
    },
    handleScroll() {
      // 变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 变量windowHeight是可视区的高度
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      // 变量scrollHeight是滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      // 滚动条到底部的条件
      if (scrollTop + windowHeight - scrollHeight>-10) {
        if (this.pageNum == this.pages || this.loading) {
          return;
        }
        if (loadTimer) {
          clearTimeout(loadTimer);
        }
        loadTimer = setTimeout(_ => {
          this.pageNum++;
          this.getGalleryList();
        }, 300);
      }
    },
    onInfoShow() {
      this.dialogUser = true;
    },
    // 获取用户的信息
    getuser() {
      this.$store.dispatch("user/getInfo").then(res => {
        this.userList = res;
      });
    },
    getAllTags() {
      this.tagList = [];
      getGalleryTagList({ tagName: "" })
        .then(res => {
          if (res.code == 200) {
            let tagList = res.data.childrens;
            tagList.forEach(item => {
              item.select = [];
              //判断有几层
              let level3List = item.childrens?.filter(obj => obj.childrens?.length > 0);
              if (level3List?.length > 0) {
                item.childrens.forEach(obj => {
                  let parentTagName = obj.tagName;
                  if (obj.childrens?.length > 0) {
                    obj.childrens?.forEach(sobj => {
                      sobj._tagName = parentTagName + "/" + sobj.tagName;
                    });
                  } else {
                    item.childrens?.forEach(obj => {
                      obj._tagName = obj.tagName;
                    });
                  }
                });
                item.level = 3;
              } else {
                item.childrens?.forEach(obj => {
                  obj._tagName = obj.tagName;
                });
                item.level = 2;
              }
            });
            this.tagList = tagList;

            console.log(tagList, "list");
          }
        })
        .finally(_ => {
          this.getGalleryList();
        });
    },
    onPopoverShow(id) {
      this.popoverId = id;
    },
    onSelectTagRemove(tag) {
      this.tagList.forEach(item => {
        item.select = item.select.filter(obj => obj.toString() != tag.toString());
      });
      this.getList();
    },
    onCascaderChange(e) {
      this.$refs["popover-" + this.popoverId][0].doClose();
      this.getList();
    },
    getGalleryList() {
      this.loading = true;
      // this.list = [];
      if (this.pageNum == 1) {
        this.list = [];
      }
      let data = {
        // moduleIds: [2],
        tagSearchValue: this.tagName,
        tagIds: this.selectTagIds,
        name: this.title,
        startTime: "",
        rootModuleId: "2",
        endTime: "",
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        status: 1,
        type: 0
      };
      getGalleryList(data)
        .then(res => {
          if (res.code == 200) {
            let records = res.data.records;
            records.forEach(item => {
              item.createTime = item.createTime.replace("T", " ").slice(0, 16);
              item.tagString = item.tags.map(tag => tag.tagName).join(",");
              item.imageShow = false
              // item.url = "../../assets/imgs/background_default@2x.png";
            });
            this.pages = res.data.pages;
            if (this.pageNum == 1) {
              this.list = res.data.records;
            } else {
              this.list = [...this.list, ...res.data.records];
            }
          }
        })
        .finally(_ => {
          this.loading = false;
        });
    },
    getList() {
      this.pageNum = 1;
      this.getGalleryList();
    },
  },
  computed: {
    selectTags() {
      let result = [];
      this.tagList.forEach(item => {
        item.select.forEach(tag => {
          if (!result.includes(tag)) {
            result.push(tag);
          }
        });
      });
      return result;
    },
    selectTagIds() {
      let result = [];
      console.log(this.tagList, "tagList");
      this.tagList?.forEach(item => {
        if (item.select.length > 0) {
          if (item.level == 2) {
            const tagName = item.select.toString();
            let selectTag = item.childrens?.find(obj => obj._tagName == tagName);
            if (selectTag) {
              result.push(selectTag.id);
            }
          }
          if (item.level == 3) {
            console.log(item, "level3");
            item.select.forEach(selItem => {
              if (selItem.length == 2) {
                item.childrens?.forEach(obj => {
                  let selectTag = obj.childrens?.find(sobj => sobj._tagName == selItem.join("/"));
                  if (selectTag) {
                    result.push(selectTag.id);
                  }
                });
              }
              if (selItem.length == 1) {
                let selectTag = item.childrens?.find(sobj => sobj._tagName == selItem.join("/"));
                if (selectTag) {
                  result.push(selectTag.id);
                }
              }
            });
            // const tagName = item.select[1];
            // item.childrens?.forEach(obj => {
            //   let selectTag = obj.childrens?.find(oo => oo.tagName == tagName);
            //   if (selectTag) {
            //     result.push(selectTag.id);
            //   }
            // });
          }
        }
      });
      return result;
    },
    noMore() {
      return this.list.length == 0 || this.pageNum == this.pages;
    },
  },
};
</script>
<style>
html,
body {
  background-color: #f4f4f5;
  height: 100%;
}
#app {
  overflow-y: auto;
}
</style>
<style lang="less" scoped>
.hideImgDiv {
  ::v-deep .el-image__inner {
    display: none;
  }
}
.image_show{
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 6px;
  text-align: center;
  float: right;
  border: none;
  background-color: rgba(255,255,255,0.8);
  color: black;
  font-weight: bold;
  margin-right: 5px;
  position: absolute;
  bottom: 0;
  right: 0;
  margin-bottom: 5px;
}
.container {
  // height: 100%;
  // display: flex;
  // flex-direction: column;
  & > .banner {
    background-color: #fff;
    flex: 0 0 auto;
    & > div {
      height: 0.68rem;
      width: 15rem;
      margin: 0 auto;
      display: flex;
      align-items: center;
      & > .logo {
        flex: 0 0 auto;
        & img {
          width: 1.17rem;
          height: auto;
        }
      }
      & > .blank {
        flex: 1;
      }
      & > .name {
        flex: 0 0 auto;
      }
    }
  }

  & > .body {
    width: 15rem;
    height: 10px;
    margin: 0 auto;
    & > .search-con {
      margin-bottom: 0.16rem;
      background-color: #fff;
      margin-top: 0.16rem;
      border-radius: 0.01rem;
      & > .title {
        line-height: 0.64rem;
        height: 0.64rem;
        font-size: 0.12rem;
        color: rgba(0, 0, 0, 0.45);
        padding-left: 0.24rem;
        border-bottom: 1px solid rgba(0, 0, 0, 0.06);
        & > span {
          color: rgba(0, 0, 0, 0.85);
        }
      }
      & > .search {
        line-height: 0.64rem;
        height: 0.64rem;
        padding-left: 0.24rem;

        & > span {
          font-size: 0.14rem;
          color: rgba(0, 0, 0, 0.85);
        }
        // & input{
        //   // border:1px solid red;
        // }
        & > .ipt {
          display: inline-block;
          width: 3.4rem;
          margin-right: 0.16rem;
          & /deep/ .el-input__inner {
            height: 0.32rem;
            // line-height: 0.32rem;
            // padding: 0;
            font-size: 0.14rem;
            padding: 0 0.12rem;
          }
          & /deep/ .el-input__icon {
            margin-top: 0.03rem;
          }
        }
        // & > input {
        //   height: 0.32rem;
        //   line-height: 0.32rem;
        //   width: 3.4rem;
        //   border-radius: 0.02rem;
        //   border: 1px solid #d9d9d9;
        //   padding: 0 0.12rem;
        //   margin-right: 0.16rem;
        //   outline: none;
        //   font-size: 0.14rem;
        //   // &:focus{
        //   //   border: none;
        //   // }
        // }
        & .el-button--mini {
          height: 0.32rem;
          width: 0.78rem;
          color: #e60027;
          border: 0.01rem solid #e60027;
          box-sizing: border-box;
          padding: 0 !important;
          font-size: 0.14rem;
        }
      }
    }
    & > .list-con {
      // padding: 0 -4rpx;
      background-color: #fff;
      & > .filter-con {
        flex: 0 0 auto;
        padding: 0.24rem;
        display: flex;
        align-items: center;
        font-size: 0.14rem;
        & > .title {
          flex: 0 0 auto;
          color: rgba(0, 0, 0, 0.85);
        }
        & > .tag-con {
          flex: 1;
          & .tag {
            display: inline-block;
            border-radius: 0.16rem;
            border: 1px solid rgba(0, 0, 0, 0.06);
            margin: 0 0.04rem;
            height: 0.32rem;
            line-height: 0.32rem;
            padding: 0 0.16rem;
            position: relative;
            cursor: pointer;
            &.active {
              background-color: #ffccc7;
              color: #e60027;
            }
          }
          & .sel-tag {
            padding: 0 0.12rem;
            background-color: #f5f5f5;
            color: rgba(0, 0, 0, 0.6);
            line-height: 0.28rem;
            height: 0.28rem;
            display: inline-block;
            font-size: 0.14rem;
            margin: 0 0.06rem;
            position: relative;
            & > .del {
              position: absolute;
              width: 0.16rem;
              height: 0.16rem;
              background: url("~@/assets/imgs/icon_gray_close@2x.png") no-repeat center center / 100% auto;
              top: -0.08rem;
              right: -0.04rem;
              cursor: pointer;
            }
          }
        }
      }
      & > .imglist {
        & > .list {
          display: flex;
          flex-wrap: wrap;
          & > .item {
            flex: 0 0 3.43rem;
            margin: 0.16rem;
            margin-bottom: 0;
            width: 3.43rem;
            & > .img {
              height: 1.9rem;
              border-radius: 0.12rem;
              overflow: hidden;
              cursor: pointer;
              position: relative;
            }
            & > .info {
              padding-bottom: 0.16rem;
              & > .title {
                font-size: 0.14rem;
                color: rgba(0, 0, 0, 0.85);
                padding-top: 0.12rem;
                font-weight: 500;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                // height: .64rem;
              }
              & > .tags {
                font-size: 0.12rem;
                color: rgba(0, 0, 0, 0.85);

                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                // & > span {
                //   font-size: 0.12rem;
                //   color: rgba(0, 0, 0, 0.85);
                //   line-height: 0.2rem;
                //   font-weight: 400;
                //   display: inline-block;
                // }
              }
              & > .date {
                color: rgba(0, 0, 0, 0.45);
                font-size: 0.12rem;
                padding-top: 0.04rem;
              }
            }
          }
        }
      }
      & .boot-txt {
        text-align: center;
        padding: 0.32rem;
        font-size: 0.14rem;
        color: rgba(0, 0, 0, 0.45);
      }
    }
  }
}

::v-deep .el-popover {
  padding: 0 !important;
}
</style>
<style lang="less">
.last-check {
  li[aria-haspopup="true"] {
    .el-checkbox {
      display: none;
    }
  }
}
</style>
